import React, { PureComponent } from 'react'

import './circle.scss'

class Circle extends PureComponent {
  getSize () {
    switch (this.props.size) {
      case 't':
        return ' size-tiny'
      case 's':
        return ' size-small'
      case 'm':
      default:
        return ' size-medium'
      case 'l':
        return ' size-large'
    }
  }

  getColor () {
    switch (this.props.color) {
      case 'green':
      default:
        return ' green'
      case 'red':
        return ' red'
      case 'brand-2':
        return ' brand-2'
    }
  }

  render () {
    return (
      <div className={'element-circle' + this.getSize() + this.getColor()} />
    )
  }
}

Circle.defaultProps = {
  size: 'm',
  color: 'green'
}

export default Circle



// WEBPACK FOOTER //
// ./src/app/shared/elements/circle/index.js